import { render, staticRenderFns } from "./QueryPage.vue?vue&type=template&id=2ad46460&scoped=true&"
import script from "./QueryPage.vue?vue&type=script&lang=js&"
export * from "./QueryPage.vue?vue&type=script&lang=js&"
import style0 from "./QueryPage.vue?vue&type=style&index=0&id=2ad46460&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad46460",
  null
  
)

export default component.exports